module.exports = __webpack_public_path__ + "img/ic_12_down.55124dc5.svg";